const dispatchGCM = (event, buttonText, page) => {
  window.dataLayer = window.dataLayer || [];
  window.dataLayer.push({
    event,
    buttonText,
    page,
  });
};

export const handleOpenLink = (url, event, buttonText, page) => {
  window.open(url, '_blank');
  if (event && buttonText && page) dispatchGCM(event, buttonText, page);
};
